import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header border-0 pt-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative my-1" }, " Education History ")
], -1)
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Add Record ")
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Edit ")
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Delete ")
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("View ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTLoader = _resolveComponent("KTLoader")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_EducationModal = _resolveComponent("EducationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_KTLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                "data-bs-toggle": "modal",
                "data-bs-target": "#kt_modal_add_customer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRecord && _ctx.addRecord(...args)))
              }, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Plus.svg" })
                ]),
                _hoisted_8
              ], 512), [
                [_vShow, !_ctx.isReview]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.tableData.length > 0)
            ? (_openBlock(), _createBlock(_component_Datatable, {
                key: 0,
                "table-data": _ctx.tableData,
                "table-header": _ctx.tableHeader,
                "enable-items-per-page-dropdown": true
              }, {
                "cell-checkbox": _withCtx(({ row: customer }) => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: customer.id
                    }, null, 8, _hoisted_11)
                  ])
                ]),
                "cell-degree_name": _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer.degree_name), 1)
                ]),
                "cell-institute_name": _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer.institute_name), 1)
                ]),
                "cell-start_date": _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer.start_date), 1)
                ]),
                "cell-left_date": _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer.left_date), 1)
                ]),
                "cell-edit": _withCtx(({ row: customer }) => [
                  (!_ctx.isReview)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.editRecord(customer.id, $event)), ["stop"]),
                        class: "btn btn-sm btn-light btn-active-light-primary m-1",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#kt_modal_add_customer"
                      }, [
                        _createElementVNode("span", _hoisted_13, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                        ]),
                        _hoisted_14
                      ], 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (!_ctx.isReview)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.deleteRecord(customer.id, $event)), ["stop"]),
                        class: "btn btn-sm btn-light btn-active-light-primary m-1"
                      }, [
                        _createElementVNode("span", _hoisted_16, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                        ]),
                        _hoisted_17
                      ], 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  (!_ctx.sReview)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.editRecord(customer.id, $event)), ["stop"]),
                        class: "btn btn-sm btn-light btn-active-light-primary m-1",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#kt_modal_add_customer"
                      }, [
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                        ]),
                        _hoisted_20
                      ], 8, _hoisted_18))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["table-data", "table-header"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_EducationModal, {
      initialData: _ctx.educationFormData,
      isReview: _ctx.isReview
    }, null, 8, ["initialData", "isReview"])
  ], 64))
}